import { COUPON_PERIOD_TYPE_V2, CouponAvailablePeriod } from '../../../../../types/coupons';
import { setDateFormat } from '../../../../../lib/moment';
import { DATE_FORMAT } from '../../../../../types/common/date';
import { setDash } from '../../../../../lib/common';

export const getCouponPeriodText = (availablePeriod: CouponAvailablePeriod) => {
  if (availablePeriod.periodType === COUPON_PERIOD_TYPE_V2.FIXED_DATE) {
    return `${setDateFormat(availablePeriod.period?.startDate, DATE_FORMAT.FULL_DASH_FORMAT)} ~ ${setDateFormat(
      availablePeriod.period?.endDate,
      DATE_FORMAT.FULL_DASH_FORMAT,
    )}`;
  }

  if (availablePeriod.periodType === COUPON_PERIOD_TYPE_V2.GENERATED_DATE)
    return `발급일 기준으로 ${setDash(availablePeriod.dayPlus)}일`;

  if (availablePeriod.periodType === COUPON_PERIOD_TYPE_V2.INFINITY) return '무기한';
};
